import { useLoadingStore, selectLoading } from '@/modules/shared/stores/loadingStore'
import * as React from 'react'
import { LoaderIcon } from '@/app/features/icons/Loader'
import { ActivitiesEmptyState } from '@/modules/shared/components/ActivitiesEmptyState'
import { ActivityListHeader } from './ActivityListHeader'
import { getVehicleActivitiesColumns } from '@/modules/vehicles/constants/tables'
import ActivityListRow from './ActivityListRow'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

const activityKey = (a: any): string =>
  a?.id != null ? `id-${a.id}` : `${a?.startTime}-${a?.type}`

const ActivityList = ({
  activities,
  onSelected,
  onEdit,
  companyId,
  onChartSaved,
  hoveredActivity,
  hoverFromChart = false,
  onActivityLeave,
}: {
  activities: any[]
  onSelected?: (activity: any) => void
  onEdit?: (activity: any) => void
  companyId?: string
  onChartSaved?: () => void
  hoveredActivity?: any
  hoverFromChart?: boolean
  onActivityLeave?: () => void
}) => {
  const loading = useLoadingStore(selectLoading)
  const { t } = useLocalize()
  // Disc id of the chart whose modal is open (set by the row's "Pokaż tarczkę"
  // button). null = no modal.
  const [chartDiscId, setChartDiscId] = React.useState<number | null>(null)
  const activityRefs = React.useRef<Map<string, HTMLTableRowElement>>(new Map())

  const VehicleActivitiesColumns = React.useMemo(
    () => getVehicleActivitiesColumns(t),
    [t],
  )

  React.useEffect(() => {
    if (!hoveredActivity || !hoverFromChart) return
    const el = activityRefs.current.get(activityKey(hoveredActivity))
    el?.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
  }, [hoveredActivity, hoverFromChart])

  return (
    <section>
      {loading ? (
        <div className="tw-grid tw-h-full tw-place-items-center">
          <LoaderIcon className="tw-w-16 tw-animate-spin" />
        </div>
      ) : activities.length > 0 ? (
        <table className="tw-w-full tw-table-auto tw-border-spacing-x-2 tw-pl-2">
          <ActivityListHeader columns={VehicleActivitiesColumns} />
          <tbody>
            {activities.map((activity, index) => (
              <ActivityListRow
                key={index}
                ref={(el) => {
                  const key = activityKey(activity)
                  if (el) activityRefs.current.set(key, el)
                  else activityRefs.current.delete(key)
                }}
                activity={activity}
                isHovered={
                  !!hoveredActivity &&
                  activityKey(hoveredActivity) === activityKey(activity)
                }
                onMouseEnter={() => onSelected?.(activity)}
                onMouseLeave={() => onActivityLeave?.()}
                // onShowChart={
                //   // SourceType.TachographChart === 3 AND a linked chart id.
                //   activity.source === 3 && activity.driverTachographChartId
                //     ? () => setChartDiscId(activity.driverTachographChartId)
                //     : undefined
                // }
              />
            ))}
          </tbody>
        </table>
      ) : (
        <div className="tw-grid tw-h-full tw-min-h-[min(100%,420px)] tw-w-full tw-place-items-center tw-px-4">
          <ActivitiesEmptyState
            title={t('dailyActivities.empty-activities-title')}
            subtitle={t('dailyActivities.empty-activities-subtitle')}
          />
        </div>
      )}

      {/* {companyId && (
        <ShowChartModal
          companyId={companyId}
          discId={chartDiscId}
          isOpen={chartDiscId != null}
          onClose={() => setChartDiscId(null)}
          onSaved={onChartSaved}
        />
      )} */}
      {/* {setChartDiscId !== null &&
        createPortal(
          <TachoDisc
            companyId={companyId}
            discId={chartDiscId}
            isOpen={chartDiscId != null}
            onClose={() => setChartDiscId(null)}
            onSaved={onChartSaved}
          />,
          document.body,
        )} */}

    </section>
  )
}

export default ActivityList
